export default {
  // mode: "dark",
  // primary: {
  //   main: "#ff0000",
  //   contrastText: "#fff",
  // },
  // secondary: {
  //   main: "#c60000",
  //   contrastText: "#fff",
  // },
  // info: {
  //   main: "#ff3030",
  //   contrastText: "#fff",
  // },
  // warning: {
  //   main: "#f2a921",
  //   contrastText: "#fff",
  // },
  // background: {
  //   default: "#000",
  //   paper: "#222",
  // },
  // text: {
  //   primary: "#f2f2f2",
  //   secondary: "#606060",
  //   warning: "#f2a921",
  //   first: "#b50000",
  //   second: "#135287",
  // },
};
